import PropTypes from "prop-types";
import React, { memo, useState } from "react";
import { apiUrl, apiUrlTruc } from "./../../config";

import { Document, Page, pdfjs } from "react-pdf";

import IFrameHttp from "./IFrameHttp";
import { findViewFile, isIOSDevice } from "../../utils/common";
import authenticationStore from "../../store/authenticationStore";
import { EmptyText } from "../common/CellText";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const PDFViewer = (props) => {
    const { file, fileId, fileType, fileName } = props;
    const [numPages, setNumPages] = useState(null);

    const isUBQLV = window.location.pathname.includes(
        "connected-committee-document"
    );
    const isFileTruc = window.location.pathname.includes("messages");

    const isPDF = ["pdf"].includes(fileType);

    const onDocumentLoadSuccess = ({ numPages }) => {
        setNumPages(numPages);
    };

    const viewFile = findViewFile(file, fileId, fileType, fileName);

    const renderContent = () => {
        if (!fileId && !file)
            return (
                <div
                    style={{ marginTop: 40 }}
                    description={
                        isIOSDevice() ? (
                            <EmptyText>Không có văn bản hợp lệ.</EmptyText>
                        ) : (
                            <EmptyText>Không có văn bản</EmptyText>
                        )
                    }
                />
            );
        if (isIOSDevice() && (isPDF || isUBQLV)) {
            return (
                <Document
                    width={"100%"}
                    height={"100%"}
                    style={{ width: "100", height: 100, overflowX: "hidden" }}
                    file={
                        isUBQLV
                            ? viewFile
                            : `${viewFile}?access_token=${
                                  JSON.parse(authenticationStore.appToken)
                                      .access_token
                              }`
                    }
                    onLoadSuccess={onDocumentLoadSuccess}
                    error="Không tải được tệp."
                >
                    {Array.from(new Array(numPages), (el, index) => (
                        <Page
                            key={`page_${index + 1}`}
                            pageNumber={index + 1}
                        />
                    ))}
                </Document>
            );
        }

        return (
            <IFrameHttp
                url={viewFile}
                isUBQLV={isUBQLV}
                isFileTruc={isFileTruc}
            />
        );
    };
    return renderContent();
};

export default memo(PDFViewer);
